import React from 'react';
import _ from 'lodash';

import Tippy, { ToolTip } from '../../components/ReactTippy';
import { USER_STATUS } from '../../utilities/constants';
import { HEAD_OFFICE_OPTION } from '../PartnerCompanyBranchDropdown';
import { getRoleNameByRoleId } from '../../utilities/roleUtility';
import { BuildeeManagerIcon } from '../../components/icons/BuildeeManagerIcon';

const tooltipStyle = {
  maxWidth: '240px',
  wordWrap: 'break-word',
  color: '#FFF',
  fontSize: '14px',
  lineHeight: '1.5',
  textAlign: 'left',
};

const WithTooltip = ({ children, data }) => (
  <Tippy
    delay={[500, 0]}
    duration={10}
    arrow={true}
    arrowType='sharp'
    placement='bottom'
    html={<ToolTip tooltipStyle={tooltipStyle}>{data}</ToolTip>}
  >
    {children}
  </Tippy>
);

const getStatusTag = flag => {
  const tags = {
    [USER_STATUS.use.id]: <div />,
    [USER_STATUS.stop.id]: <div className='status--long--caution'>停止中</div>,
  };
  return tags[flag] || <div />;
};

export const PartnerUserTableHeadings = ({ joiningFlag }) => {
  const headings = [
    '支店',
    '氏名',
    '氏名ふりがな',
    'ID',
    '種別',
    'サービス権限',
    '登録日',
    '更新日',
    'ステータス',
    '',
  ];

  if (!joiningFlag) {
    _.remove(headings, item => item === '支店');
  }

  const renderHeadings = heading => (
    <td key={heading} className='value-table value-table--table__label'>
      <div className='value-table__label'>{heading}</div>
    </td>
  );

  return (
    <thead className='table__header'>
      <tr className='table__label'>{_.map(headings, renderHeadings)}</tr>
    </thead>
  );
};

/**
 * 協力会社ユーザー一覧テーブル部分
 * @param userList {array} 一覧情報
 * @param callbacks {func}
 */
export const PartnerUserTableContents = ({
  userList,
  callbacks,
  joiningFlag,
}) => {
  /**
   * @description サービスのアイコン設定
   * @param {object} permissions サービス権限
   */
  const renderServiceIcons = permissions => {
    let icons = [];
    if (permissions) {
      // 調整会議
      if (permissions.use_chosei_flg) {
        icons.push(<div className='option-icon-chosei' />);
      } else {
        icons.push(<div className='option-icon-empty' />);
      }
      // 入退場
      if (permissions.use_nyutaijo_flg) {
        icons.push(<div className='option-icon-entrance' />);
      } else {
        icons.push(<div className='option-icon-empty' />);
      }
      // 労務安全
      if (permissions.use_green_file_flg) {
        icons.push(<div className='option-icon-greenfile' />);
      } else {
        icons.push(<div className='option-icon-empty' />);
      }
      return _.map(icons, (icon, i) => (
        <span
          key={`value-table__content-no.${i}`}
          className='value-table__content'
        >
          {icon}
        </span>
      ));
    }
    return null;
  };

  const showBuildeeManagerIcon = permissions => {
    if (permissions) {
      if (permissions.buildee_manager_flg) {
        return <BuildeeManagerIcon className={`icon--2x`} />;
      }
    }
    return null;
  };

  return (
    <tbody>
      {_.map(userList, user => (
        <tr className='table__item' key={user.id}>
          {!!joiningFlag && (
            <td className='value-table construction-list-value-table__name'>
              <span className='label'>支店</span>
              <WithTooltip
                data={_.get(
                  user,
                  'partner_company_branch.name',
                  HEAD_OFFICE_OPTION.name
                )}
              >
                <div className='value-table__txt--10'>
                  {_.get(
                    user,
                    'partner_company_branch.name',
                    HEAD_OFFICE_OPTION.name
                  )}
                </div>
              </WithTooltip>
            </td>
          )}
          <td className='value-table construction-list-value-table__branch-name'>
            <WithTooltip data={_.get(user, 'fullname', '')}>
              <div
                className='value-table__txt--7'
                style={{
                  maxWidth: '220px',
                  textOverflow: 'ellipsis',
                }}
              >
                {_.get(user, 'fullname', '')}
              </div>
            </WithTooltip>
          </td>
          <td className='value-table construction-list-value-table__name'>
            <span className='label'>氏名ふりがな</span>
            <WithTooltip data={_.get(user, 'fullname_kana', '')}>
              <div className='value-table__txt--10'>
                {_.get(user, 'fullname_kana', '')}
              </div>
            </WithTooltip>
          </td>
          <td className='value-table construction-list-value-table__name'>
            <span className='label'>ID</span>
            <WithTooltip data={_.get(user, 'login_id', '')}>
              <div className='value-table__txt--10'>
                {_.get(user, 'login_id', '')}
              </div>
            </WithTooltip>
          </td>
          <td className='value-table construction-list-value-table__address'>
            <span className='label'>種別</span>
            <div className='value-table__txt--10 value-table__user-type'>
              {showBuildeeManagerIcon(user.permissions)}
              {getRoleNameByRoleId(user.user_role_code)}
            </div>
          </td>
          <td className='value-table construction-list-value-table__address'>
            <span className='label'>サービス権限</span>
            <div className='value-table__txt--10'>
              {renderServiceIcons(user.permissions)}
            </div>
          </td>
          <td className='value-table construction-list-value-table__date'>
            <span className='label'>登録日</span>
            <div className='value-table__date'>{user.created_at}</div>
          </td>
          <td className='value-table construction-list-value-table__date'>
            <span className='label'>更新日</span>
            <div className='value-table__date'>{user.updated_at}</div>
          </td>
          <td className='value-table construction-list-value-table__date'>
            <span className='label'>ステータス</span>
            <div className='value-table__txt--10'>
              {getStatusTag(user.block_flag)}
            </div>
          </td>
          <td className='value-table construction-list-value-table__edit'>
            <div className='value-table__normal'>
              <button
                className='btn--sm--stay'
                onMouseDown={() => callbacks.table.edit(user)}
              >
                確認
              </button>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  );
};



// WEBPACK FOOTER //
// ./src/components/tables/PartnerUsers.jsx